/**
 * FAK (Form-Ansicht-Karte) State - Svelte 5 Runes
 *
 * This module holds FAK-related state in Svelte 5 territory.
 * It bridges to legacy fakStores when needed, but is the source of truth
 * for the /maplibre route.
 *
 * Legacy stores (fakStores.ts) cannot be modified - they're shared with /map route.
 */

import { mapFormControls } from '#lib/map/fak/utils/fakStores.js'

class FakState {
	isOpen = $state(false)
	projectId: string | null = $state(null)
	lotId: string | null = $state(null)

	/* current level (1=project, 2=lots, 3=lot details) */
	level: number = $state(0)

	/**
	 * Mirror into legacy mapFormControls via .update() (not .set()): keeps fields like
	 * `saving`, and Basic.svelte only shows the page-wide notifications when level === 0.
	 */
	#syncMapFormControls(projectId: string | null, lotId: string | null, level: number) {
		mapFormControls.update((controls) => {
			controls.projectId = projectId
			controls.lotId = lotId
			controls.level = level
			return controls
		})
	}

	open(params: { projectId?: string | null; lotId?: string | null }) {
		const { projectId = null, lotId = null } = params

		this.projectId = projectId
		this.lotId = lotId
		this.isOpen = true

		/* compute level explicitly - avoids $derived reactive chain */
		if (lotId) {
			this.level = 3
		} else if (projectId) {
			this.level = 2
		} else {
			this.level = 1
		}

		this.#syncMapFormControls(projectId, lotId, this.level)
	}

	close() {
		this.isOpen = false
		this.projectId = null
		this.lotId = null
		this.level = 0

		this.#syncMapFormControls(null, null, 0)
	}
}

export const fakState = new FakState()
